// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/@appBar/:path*\",\"regex\":\"^/@appBar/(.+)$\",\"paramNames\":[\"path\"],\"hasOptionalPrefix\":false},{\"path\":\"/@appBar/clients/:id*\",\"regex\":\"^/@appBar/clients/(.+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/clients/:id\",\"regex\":\"^/clients/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/clients/:id/assets\",\"regex\":\"^/clients/([^/]+)/assets$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/clients/:id/debug\",\"regex\":\"^/clients/([^/]+)/debug$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/clients/:id/retirement\",\"regex\":\"^/clients/([^/]+)/retirement$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/clients/:id/salary\",\"regex\":\"^/clients/([^/]+)/salary$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/clients/:id/tables\",\"regex\":\"^/clients/([^/]+)/tables$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/clients/:id/transactions\",\"regex\":\"^/clients/([^/]+)/transactions$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/@appBar\"},{\"path\":\"/admin\"},{\"path\":\"/auth/set-password\"},{\"path\":\"/clients\"},{\"path\":\"/globals\"},{\"path\":\"/portfolios\"},{\"path\":\"/auth/forgot-password\"},{\"path\":\"/auth/invite-callback\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/login\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.1";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';

const enabled = process.env.NODE_ENV !== 'development';

const isCi = process.env.CI === 'true';
const isProductionBuild = process.env.NODE_ENV === 'production';
const isVercelProduction =
  process.env.VERCEL_ENV === 'production' || process.env.VERCEL === '1';

const enableReplays =
  enabled && !isCi && isProductionBuild && isVercelProduction;

Sentry.init({
  enabled,
  dsn: 'https://6b772ef3709c0cff0d61ae05a3e3499d@o4509421130743808.ingest.us.sentry.io/4509421130940416',

  // Add optional integrations for additional features
  integrations: [
    ...(enableReplays ? [Sentry.replayIntegration()] : []),
    Sentry.browserTracingIntegration(),
    Sentry.browserSessionIntegration(),
    Sentry.consoleLoggingIntegration(),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: enableReplays ? 0.1 : 0,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: enableReplays ? 1.0 : 0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Enable logs to be sent to Sentry
  enableLogs: true,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
